module.exports = __webpack_public_path__ + "static/media/breakfast-brunch-desktop-1220x150@2x.95ccf5e4.webp";